
import React from 'react';
import { DashboardRouter } from 'routes';

function Dashboard() {
    return (
        <DashboardRouter />
    );
}

export default Dashboard;

